import { graphql } from "gql";

const CREATE_MESSAGE_THREAD_MUTATION = graphql(`
  mutation CreateMessageThread(
    $input: MessageThreadInput!
    $messageInput: MessageInput!
  ) {
    createMessageThread(input: $input, messageInput: $messageInput) {
      ...MessageThread
    }
  }
`);

export default CREATE_MESSAGE_THREAD_MUTATION;
